import { Tour } from "nextstepjs";
import { getDeviceType } from "@/helpers/storeLocatorHelper";
const deviceType = getDeviceType();

const recipeDetailGuide: Tour[] = [
  {
    tour: "recipeDetailTour",
    steps: [
      {
        icon: "",
        title: "",
        content: "Add this ingredient to your shopping list.",
        selector: "#add_to_shopping_list",
        side: deviceType === "mobile" ? "top-left" : "top-right",
        showControls: true,
        showSkip: true,
        pointerPadding: 5,
        pointerRadius: 10,
      },
      {
        icon: "",
        title: "",
        content:
          "Save your favorite recipes for easy access by adding them to My Recipe Lists.",
        selector: "#create_new_recipeList",
        side: "top-right",
        showControls: true,
        showSkip: true,
        pointerPadding: 5,
        pointerRadius: 10,
      },
      {
        icon: "",
        title: "",
        content: "Print or share your favorite recipes to stay organized.",
        selector: "#print_recipeList_mobile",
        side: deviceType === "mobile" ? "top-left" : "top-left",
        showControls: true,
        showSkip: true,
        pointerPadding: 5,
        pointerRadius: 10,
      },
      {
        icon: "",
        title: "",
        content: "Print or share your favorite recipes to stay organized.",
        selector: "#print_recipeList_desktop",
        side: "top-left",
        showControls: true,
        showSkip: true,
        pointerPadding: 5,
        pointerRadius: 10,
      },
    ],
  },
];

export default recipeDetailGuide;
